<template lang="html">
  <div class="edit-site-theme tier tier-three">
    <Tooltip
      content="All optimsed for maximum conversion, themes can be activated without losing content"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Themes
        :themes="themes"
        :site="site"
        :activeTheme="activeTheme"
        @setTheme="setTheme"
        @handleHeightChange="handleHeightChange(0)"/>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'
import {readThemesData} from '@/lib/themes'

import Tooltip from '@/components/Tooltip'
import Themes from '@/components/Themes'

export default {
  name: 'EditSiteTheme',

  components: {
    Tooltip,
    Themes
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String,
    activeMode: String
  },

  data() {
    return {
      site: {},
      themesLoaded: false,
      themes: []
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} Theme`
    },

    activeTheme() {
      return this.themes.find((theme) => {
        return theme.id === this.site.theme_id
      })
    },

    themeOptions() {
      return this.themes.map((theme) => {
        return {
          key: theme.name,
          value: theme.id
        }
      })
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Theme applied to ${this.site.name}!`
      }
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site).then(() => {
        this.$emit('updatePage')
        this.triggerNotification('success', 'Theme', 'applied')
      })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })

      readThemesData().then(({data}) => {
        this.themes = data
      })
    },

    setTheme(theme) {
      this.site.theme_id = theme.id
      this.submitSite()
    },

    handleHeightChange(index) {
      /**
       * When expanding a theme, it should update the height of the tab
       */
      this.$refs.themeTabs.setHeight(index)
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
